import React from 'react';
import classNames from 'classnames';

import {ErrorField} from 'components/Fields';
import Select from 'components/Select';

import './styles.css';

const SelectField = ({
  input: {onBlur, onChange, value},
  options,
  className,
  meta: {touched, error},
  disabled,
  placeholder,
  dark
}: any) => {
  return (
    <div className="SelectField">
      <Select
        className={classNames(
          {error: touched && error},
          {disabled},
          className,
          'select'
        )}
        dark={dark}
        options={options}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        placeholder={placeholder}
      />
      <ErrorField touched={touched} error={error} />
    </div>
  );
};

export default SelectField;
